import React, { useState } from "react";
import {
  Box,
  Grid,
  Button,
  Typography,
  IconButton,
  CircularProgress,
  TextField,
} from "@mui/material";
import {
  Close as CloseIcon,
  CancelRounded as CancelRoundedIcon,
  PictureAsPdf as PictureAsPdfIcon,
  Delete as DeleteIcon,
  Image as ImageIcon,
} from '@mui/icons-material';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import ModalAddMedicalFile from '../../GeneralComponents/ModalDetalle';
import LoaderModals from '../../GeneralComponents/Loader_modals';
import InputFileList from "../../GeneralComponents/InputFileList";
import SnackBar from "../../GeneralComponents/Snackbar";
import { uploadMedicalDocuments, removeDocuments_request } from '../../../services/documents_services';
import { Empty } from 'antd';
import { FileWordOutlined } from '@ant-design/icons';
import ConfirmDialog from "../../Utils/ConfirmDialog";
import DocumentItem from "./DocumentItem";

const styleDet = {
  height: "clac(100vh - 52px)",
  width: "clac(100vw - 52px)",
  margin: "0 2%",
};

const mainStyle = {
  height: 'calc(100vh - 80px)',
  overflowY: 'auto',
  paddingRight: '8px'
};

const itemBoxStyle = {
  mt: 1,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '5px',
  paddingLeft: '10px',
};

const itemStyle = {
  cursor: "pointer",
  width: '100%',
  padding: '5px',
  paddingLeft: '10px'
};

const iconDeleteStyle = {
  position: 'absolute',
  top: '50%',
  right: '10px',
  transform: 'translateY(-50%)',
  opacity: 0,
  transition: 'opacity 0.3s ease',
};

const mainBackground = '#eaeef0';
const standardColor = '#fff';

const iframeBoxStyle = { width: '100%', height: 'calc(100vh - 80px)' };

function DocumentHistoryFiles({ isOpenModal, closeModal, contact, documents, reloadList, loading }) {
  const [loaderDetalle, setLoaderDetalle] = useState(false);
  const [imagenesListError, setImagenesListError] = useState("true");
  const [ImagesList, setImagesList] = useState([]);
  const [openMessageError, setOpenMessageError] = useState(false);
  const [typeMessage, setTypeMessage] = useState('');
  const [message, setMessage] = useState();
  const [documentUrl, setDocumentUrl] = useState();
  const [selectedItem, setSelectedItem] = useState();
  const [deletingItem, setDeletingItem] = useState();
  const [emptyArrayDeleteFiles, setEmptyArrayDeleteFiles] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState();
  const [openSnackbarMensaje, setOpenSnackbarMensaje] = useState();
  const [typeMessageSnackbar, setTypeMessageSnackbar] = useState();
  const [isDeleting, setIsDeleting] = useState(false);
  const [openDialogConfirm, setOpenDialogConfirm] = useState(false);
  const [documentId, setDocumentId] = useState();
  const [notes, setNotes] = useState();

  const handleUploadFiles = async () =>{
    if (ImagesList.length === 0) {
      setImagenesListError("false");
      setOpenMessageError(true);
      setTypeMessage('error');
      setMessage('Debes agregar al menos 1 documento.');
      return;
    }
    setLoaderDetalle(true);
    let data = new FormData();
    data.append("IdContacto", contact.id);
    data.append("Notas", notes);
    ImagesList.forEach((element, index) => {
      data.append(`documents[${index}]`, element.file, element.name);
    });

    await uploadMedicalDocuments(contact.id, data).then(response =>{
      reloadList();
      setLoaderDetalle(false);
      setImagesList([]);
      setNotes('');
      closeModal(true);
    }).catch(error=>{
      console.error(error);
      setLoaderDetalle(false);
    });
  };

  const handleSetUrlDocument = (document) => {
    const wordExtentions = [
      "doc",   // Word 97–2003 document
      "docx",  // Word 2007+ document (Open XML)
      "dot",   // Word 97–2003 template
      "dotx",  // Word 2007+ template
    ]

    let viewerUrl = `https://${document.Multimedia}`;
    const documentExtention = document.Nombre.substring(document.Nombre.lastIndexOf(".") + 1);
    if (wordExtentions.includes(documentExtention)) {
      const encodeUrlDocument = encodeURIComponent(viewerUrl);
      viewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeUrlDocument}`;
    }

    setDocumentUrl(viewerUrl);
    setSelectedItem(document.IdDocumento);
  }

  const renderIconFile = (document) =>{
    const documentExtention = document.Nombre.substring(document.Nombre.lastIndexOf(".") + 1);
    switch (documentExtention) {
      case 'docx':
      case 'doc':
      case 'dot':
      case 'dotx':
        return <FileWordOutlined style={{ color: '#436170', fontSize: '35px' }} />;
      case 'png':
      case 'jpeg':
      case 'jpg':
        return <ImageIcon sx={{ color: '#436170', fontSize: '35px' }} />;
      case 'pdf':
        return <PictureAsPdfIcon sx={{ color: '#cb5959', fontSize: '35px' }} />
      default:
        return <InsertDriveFileIcon sx={{ color: '#436170', fontSize: '35px' }} />;
    }
  };

  const deleteFileNow = async () =>{
    setOpenDialogConfirm(false);
    setIsDeleting(true);
    setDeletingItem(documentId);
    let response = await removeDocuments_request(documentId);
    if (response.ok) {
      reloadList();
      setIsDeleting(false);
      setDocumentUrl('');
      setSelectedItem('');
    } else {
      setOpenSnackbar(true);
      setSnackbarMessage('Hubo un error al intentar eliminar el archivo.');
      setTypeMessageSnackbar('warning');
      setOpenSnackbarMensaje(true);
      setIsDeleting(false);
    }
  };

  const handleRemove = (id) => {
    setDocumentId(id);
    setOpenDialogConfirm(true);
  };

  const handleCloseDialogConfirm = () => {
    setOpenDialogConfirm(false);
  };

  return (
    <Box>
      <ConfirmDialog
        openDialog={openDialogConfirm}
        onClose={handleCloseDialogConfirm}
        title={'¿Está por eliminar esta documento?'}
        description={'Los registros eliminados ya no se pueden recuperar. ¿Desea continuar?'}
        onAccept={deleteFileNow}
        onCancel={handleCloseDialogConfirm}
      />
      <SnackBar
          open={openSnackbar}
          message={snackbarMessage}
          setOpen={setOpenSnackbarMensaje}
          typeMessage={typeMessageSnackbar}
      />
      <Grid container spacing={2}>
        <Grid item xs={4} sx={{ backgroundColor: mainBackground }}>
          <Box sx={mainStyle} >
            {loading ? <Box sx={{ display: 'flex', justifyContent: 'center' }}><LoaderModals className={"MidModalEstud"} /></Box> : (
              documents?.length === 0 ? (
                <Empty
                description={
                  <span style={{ color: "black" }}>Sin documentos</span>
                }
              />
              ) : (
                documents?.map((document, index) =>{
                  return (
                  <Box key={index} sx={{
                    ...itemBoxStyle,
                    backgroundColor: selectedItem === document.IdDocumento ? mainBackground : standardColor,
                    border: selectedItem === document.IdDocumento ? '1px solid #fff' : '',
                    position: 'relative',
                    '&:hover': {
                      '& .icon-button': {
                        opacity: 1,
                      }
                    },
                   }}>
                    {renderIconFile(document)}
                    <DocumentItem document={document} handleSetUrlDocument={handleSetUrlDocument} itemStyle={itemStyle} />
                    {
                      isDeleting && deletingItem === document.IdDocumento ? <CircularProgress /> : (
                        <IconButton aria-label="delete" onClick={()=>handleRemove(document.IdDocumento)}
                          className='icon-button'
                          sx={iconDeleteStyle}>
                          <DeleteIcon color="error" />
                        </IconButton>
                      )
                    }
                  </Box>
                  )
                })
              )
            )}
          </Box>
        </Grid>
        <Grid item xs={8} width={'65%'} >
          <div style={iframeBoxStyle}>
            <iframe
              src={documentUrl}
              width="100%"
              height="100%"
              title="Documento"
              frameBorder="0"
            />
          </div>
        </Grid>
      </Grid>
      <ModalAddMedicalFile
        isOpen={isOpenModal}
        closeModal={closeModal}
        styleDet={styleDet}
      >
        <div className="TopModalNewEstud">
          Cargar documento
          <CloseIcon style={{ cursor: "pointer", fontSize: "20px" }} onClick={() => {
            closeModal(true);
          }} />

        </div>
        {loaderDetalle ? (<LoaderModals className={"MidModalEstud"} />) : (
          <div className="MidModalEstud">
            <Box sx={{
              display: 'flex',
              justifyContent: 'center',
              mt: 2,
              mb: 2,
              backgroundColor: mainBackground,
              borderRadius: '5px',
              padding: '10px'
            }}>
              <Typography variant="subtitle1">
                Por favor. Adjunte el documento o listado de documentos
              </Typography>
            </Box>
            <Box sx={{
              display: 'flex',
              justifyContent: 'center',
              mt: 2,
              mb: 2,
              borderRadius: '5px',
              padding: '10px'
            }}>
              <TextField
                size="small"
                label="Notas"
                rows={4}
                multiline
                variant="outlined"
                fullWidth
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                    '&:hover fieldset': {
                      borderColor: '#1677ff',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#1677ff',
                    },
                  },
                  '& label.Mui-focused': {
                    color: '#1677ff',
                  },
                }}
              />
            </Box>
            <div style={{ display: "flex", alignItems: "center" }}>
              {(imagenesListError === "false") && <>
                <CancelRoundedIcon color="error" />&nbsp;
                <Typography color={'error'} style={{ fontSize: "14px" }}>Debe adjuntar un archivo</Typography>
              </>}
            </div>
            <div style={{ textAlign: "center", marginTop: 4, marginBottom: 4 }}>
              <InputFileList valueArrayImg={ImagesList} arrayImg={setImagesList} formatos={5}
                  deleteFiles={setEmptyArrayDeleteFiles}
                  extras={[
                    openMessageError,
                    typeMessage,
                    message, (temp) => {
                    if (temp.length > 0) {
                      setImagenesListError("true");
                    }
                  }
                  ]}
                activeChecks={false}
              />
            </div>
            <div>
              <div className="Filtro3Botones">
                <Button
                  type="button"
                  id="boton_guardar"
                  onClick={handleUploadFiles}
                >
                  Guardar
                </Button>
              </div>

            </div>
          </div>
        )}
      </ModalAddMedicalFile>
    </Box>
  )
}

export default DocumentHistoryFiles;
